import React, { useEffect } from "react";
import { Input } from "../../components/forms";
import { useFormik } from "formik";
import * as Yup from "yup";
import Button from "../../components/Button";
import { useState } from "react";
import InvitedAccepted from "../../components/modal/InviteAccepted";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import nProgress from "nprogress";
import { useDispatch, useSelector } from "react-redux";
import {
  acceptResellerInvitation,
  loginInvitedUser,
  loginUser,
  setInvitedUserDetails,
} from "../../features/user/userSlice";

const InviteLogin = () => {
  const [showAcceptedModal, setShowAcceptedModal] = useState(false);
  const [userDeets, setUserDeets] = useState({});
  const location = useLocation();

  const token = location.search.split("?")[1]?.split("&")[0];

  const dispatch = useDispatch();
  const {
    invitedUserDetails,
    isLoading,
    user: loginUserData,
  } = useSelector((store) => store.user);
  const navigate = useNavigate();
  const invitedUser = localStorage.getItem("inviteData");
  const user = invitedUser ? JSON.parse(invitedUser) : null;

  const verifyInvite = async () => {
    if (user?.token) return;
    if (token) {
      localStorage.removeItem("userProvider");
      try {
        nProgress.start();
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}provider/extract/claims`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        );
        if (response.status === 200) {
          nProgress.done();
          const data = await response?.data;
          localStorage.setItem("inviteData", JSON.stringify(data));
          toast.success(response?.data?.message);
          setUserDeets(response?.data?.data);
          dispatch(setInvitedUserDetails(data));
        }
      } catch (error) {
        nProgress.done();
        console.log(error);
        toast.error(error?.response?.data?.message);
      }
    } else {
      console.log("Token not found");
      toast?.error("Token not found");
    }
  };

  useEffect(() => {
    localStorage.removeItem("userProvider");
    verifyInvite();
  }, [token]);

  useEffect(() => {
    if (isLoading) {
      nProgress.start();
    } else {
      nProgress.done();
    }
  }, [isLoading]);

  useEffect(() => {
    if (user?.token) {
      navigate("/review");
    }
  }, [navigate, user]);

  // Replace with actual loading state if needed

  const schema = Yup.object({
    password: Yup.string().required("Required"),
    confirmPassword: Yup.string().oneOf(
      [Yup.ref("password"), null],
      "Passwords must match"
    ),
  });

  const { handleSubmit, handleChange, handleBlur, touched, values, errors } =
    useFormik({
      initialValues: {
        password: "",
        confirmPassword: "",
      },
      validationSchema: schema,
      onSubmit: (values) => {
        if (userDeets?.newProvider) {
          dispatch(
            loginInvitedUser({
              email: invitedUserDetails?.data?.email,
              password: values.password,
              providerName: invitedUserDetails?.data?.providerName,
              resellerId: invitedUserDetails?.data?.resellerId,
              token: token,
            })
          ).then((res) => {
            if (res?.type === "user/loginInvitedUser/fulfilled") {
              if (invitedUserDetails?.data?.newProvider) {
                localStorage.setItem(
                  "loginInfo",
                  JSON.stringify({
                    username: invitedUserDetails?.data?.email,
                    password: values.password,
                  })
                );
                navigate("/review");
              }
            }
          });
        } else {
          dispatch(
            acceptResellerInvitation({
              email: invitedUserDetails?.data?.email,
              providerName: invitedUserDetails?.data?.providerName,
              resellerId: invitedUserDetails?.data?.resellerId,
              providerCategoryIds:
                invitedUserDetails?.data?.providerCategories?.map(
                  (ids) => ids?.id
                ),
            })
          ).then((res) => {
            if (res?.type === "user/acceptResellerInvitation/fulfilled") {
              localStorage.setItem(
                "loginData",
                JSON.stringify(invitedUserDetails?.data?.email)
              );
              dispatch(
                loginUser({
                  username: invitedUserDetails?.data?.providerUsername,
                  password: values.password,
                })
              ).then((res) => {
                if (res?.type === "user/loginUser/fulfilled") {
                  navigate("/");
                }
              });
            }
          });
        }
      },
    });

  return (
    <>
      <div className="auth__form--content invite__form">
        <div className="auth__form--header">
          <div className="header__container">
            <div className="header__container--content">
              <h3 className="font-semibold text-[28px] leading-[100%] text-[#000B14]">
                Invitation from{" "}
                <span>{invitedUserDetails?.data?.resellerName}</span>!
              </h3>
              <p className="tx-c">
                {" "}
                {userDeets?.newProvider
                  ? "Sign up to confirm your business details and review the invite"
                  : "Login to accept invite."}{" "}
              </p>
            </div>
          </div>
        </div>
        <form className="__form" onSubmit={handleSubmit}>
          <Input
            type="text"
            id="username"
            value={
              userDeets?.newProvider
                ? userDeets?.email
                : userDeets?.providerUsername
            }
            onChange={handleChange}
            onBlur={handleBlur}
            label="Username"
            name="username"
            disabled={true}
            error={
              touched.username && errors.username ? (
                <small className="error">{errors.username}</small>
              ) : null
            }
          />

          <Input
            type="password"
            id="password"
            value={values.password}
            onChange={handleChange}
            onBlur={handleBlur}
            label="Password"
            name="password"
            error={
              touched.password && errors.password ? (
                <small className="error">{errors.password}</small>
              ) : null
            }
          />
          {userDeets?.newProvider && (
            <Input
              type="password"
              id="confirmPassword"
              value={values.confirmPassword}
              onChange={handleChange}
              onBlur={handleBlur}
              label="Confirm Password"
              name="confirmPassword"
              error={
                touched.confirmPassword && errors.confirmPassword ? (
                  <small className="error">{errors.confirmPassword}</small>
                ) : null
              }
            />
          )}

          <Button
            variant="primary"
            type="submit"
            className="mt-10"
            block
            disabled={isLoading}
          >
            {isLoading
              ? "Loading..."
              : invitedUserDetails?.data?.newProvider
              ? "Sign up and accept invite"
              : "Log In"}
          </Button>
        </form>
        {/* <p className="32 tx-c extralinnk">
        {"You don't have a provider account?"}{" "}
        <Link className="btn btn--link btn--link-secondary" to="/auth/signup">
          Create an account
        </Link>
      </p> */}
      </div>
      {showAcceptedModal && (
        <InvitedAccepted
          setShowAcceptedModal={setShowAcceptedModal}
          showAcceptedModal={showAcceptedModal}
        />
      )}
    </>
  );
};

export default InviteLogin;
